import * as React from "react";
import * as ReactDOM from "react-dom";

import { L2Container } from "./L2Container.web";

const root = document.getElementById("l2-container");

const renderApp = () => {
  // eslint-disable-next-line react/no-deprecated
  ReactDOM.render(<L2Container />, root);
};

renderApp();

export {};
